// BottomNavigation.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RiHome4Line, RiHome4Fill } from 'react-icons/ri';
import { HiOutlineBuildingOffice2, HiBuildingOffice2 } from 'react-icons/hi2';
import { MdArrowForward } from 'react-icons/md';

const BottomNavigation = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isMobile) {
    return null;
  }

  const isHomeActive = location.pathname === '/';
  const isCorporateActive = location.pathname === '/corporate';

  return (
    <div className="fixed bottom-4 left-0 right-0 z-50 flex justify-center pointer-events-auto px-4">
      <nav className="w-fit bg-white/95 backdrop-blur-xl rounded-full shadow-[0_12px_40px_rgba(0,0,0,0.18)] border border-gray-100/90 p-2 pl-3 flex items-center gap-3 sm:gap-4">
        
        {/* Home Tab */}
        <Link
          to="/"
          className={`flex flex-col items-center px-2 py-0.5 rounded-2xl transition-all duration-300 ${
            isHomeActive
              ? 'text-[#FF410B] font-bold scale-105'
              : 'text-gray-600 hover:text-gray-900 font-semibold'
          }`}
        >
          {isHomeActive ? (
            <RiHome4Fill className="text-xl text-[#FF410B]" />
          ) : (
            <RiHome4Line className="text-xl" />
          )}
          <span className="text-[11px] mt-0.5 leading-none">Home</span>
        </Link>

        {/* Corporate Tab */}
        <Link
          to="/corporate"
          className={`flex flex-col items-center px-2 py-0.5 rounded-2xl transition-all duration-300 ${
            isCorporateActive
              ? 'text-[#FF410B] font-bold scale-105'
              : 'text-gray-600 hover:text-gray-900 font-semibold'
          }`}
        >
          {isCorporateActive ? (
            <HiBuildingOffice2 className="text-xl text-[#FF410B]" />
          ) : (
            <HiOutlineBuildingOffice2 className="text-xl" />
          )}
          <span className="text-[11px] mt-0.5 leading-none">Corporate</span>
        </Link>

        {/* Prominent Order Now CTA Button */}
        <a
          href="https://falhari.order.food-pe.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gradient-to-r from-[#FF410B] to-[#ff5c2b] hover:from-[#e03709] hover:to-[#FF410B] text-white text-xs font-bold px-4 py-2.5 rounded-full shadow-md shadow-orange-500/25 hover:shadow-lg hover:shadow-orange-500/35 flex items-center gap-1.5 whitespace-nowrap shrink-0 transform active:scale-95 transition-all duration-200 ml-1"
        >
          <span className="whitespace-nowrap">Order Now</span>
          <MdArrowForward className="text-sm shrink-0" />
        </a>

      </nav>
    </div>
  );
};

export default BottomNavigation;
